// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"65226869","135":"87eb2d99","224":"b4181037","481":"724ca751","513":"fe1e0dd0","563":"75a520af","567":"115d3c10","773":"9280b89b","962":"da41b05a"}[chunkId] + ".chunk.js";
};